import { render } from "./SelectLocale.vue?vue&type=template&id=cc0da2f2&scoped=true"
import script from "./SelectLocale.vue?vue&type=script&lang=js"
export * from "./SelectLocale.vue?vue&type=script&lang=js"

import "./SelectLocale.vue?vue&type=style&index=0&id=cc0da2f2&scoped=true&lang=css"

import exportComponent from "D:\\nextinnoivation-home\\yecheonmuseum-web-ar-release-ycg-1.0.0\\frontend\\user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc0da2f2"]])

export default __exports__